module.exports = __webpack_public_path__ + "assets/img/ticket.f3bf39e5.png";